import type { State } from '../../types';
import { issuesNotDeleted } from './issues-not-deleted';
import { isIssueProcessed } from './is-issue-processed';
import { toIssueViewModel } from './to-issue-view-model';
import { employeesNotDeleted } from '../employees/employees-not-deleted';
import type { IssueEscalationCandidate } from '../../../content/issues/issue-escalation';
import { t } from 'src/i18n';

/**
 * Aktive (ikke ferdigbehandlede) avvik som ikke-sensitiv oppsummering for
 * eskalering (krav 1.2.1). Bevisst uten beskrivelse/tiltak/navn på
 * involverte – kun registreringsdato, status og ansvarlig. Brukes både av
 * avvikssiden og oversiktswidgeten.
 */
export function issueEscalationCandidates(state: State, hrefPrefix: string): IssueEscalationCandidate[] {
  const employeeNames = new Map(employeesNotDeleted(state).map((e) => [e.uuid, e.name]));
  return issuesNotDeleted(state)
    .map((i) => toIssueViewModel(i))
    .filter((i) => !isIssueProcessed(i))
    .filter((i) => !!i.reportedDate)
    .map((i) => ({
      uuid: i.uuid,
      reportedDate: i.reportedDate ?? '',
      deadline: i.deadline,
      responsibleName: i.processedBy ? (employeeNames.get(i.processedBy) ?? '') : '',
      statusLabel: i.processedBy ? t('issues.escalation.statusProcessing') : t('issues.escalation.statusRegistered'),
      href: hrefPrefix + 'issues/' + i.uuid,
    }));
}
